
const environment = process.env.REACT_APP_ENV || 'development';

const config = {
    development: {
        api_url:"http://localhost:8080",
        web_url:"http://localhost:3000",
        is_production: false,
        basename:"/"
    },
    production: {
        api_url:"https://api.emiratesmade.ae",
        web_url:"https://www.emiratesmade.ae",
        is_production: true,
        basename:"/"
    },
  };
  console.log(environment);
const appConfig = config[environment];

export default appConfig;